module.exports = __webpack_public_path__ + "img/set_wallpaper_4.dd7b283c.png";